export default {"src":"/_next/static/media/dbuzz.fd324dc2.svg","height":582,"width":582,"blurWidth":0,"blurHeight":0};